import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomeownerAuthContext = createContext(null);

export function HomeownerAuthProvider({ children }) {
  // null = checking, false = signed out, object = signed in
  const [session, setSession] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/homeowner/me`, { withCredentials: true });
      setSession(data);
      return data;
    } catch {
      setSession(false);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const requestOtp = useCallback(async (email) => {
    const { data } = await axios.post(`${API}/homeowner/request-otp`, { email }, { withCredentials: true });
    return data;
  }, []);

  const verifyOtp = useCallback(async (email, code) => {
    const { data } = await axios.post(`${API}/homeowner/verify-otp`, { email, code }, { withCredentials: true });
    await refresh();
    return data;
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await axios.post(`${API}/homeowner/logout`, {}, { withCredentials: true }); } catch { /* ignore */ }
    setSession(false);
  }, []);

  return (
    <HomeownerAuthContext.Provider value={{ session, refresh, requestOtp, verifyOtp, logout }}>
      {children}
    </HomeownerAuthContext.Provider>
  );
}

export const useHomeownerAuth = () => useContext(HomeownerAuthContext);

export function formatOtpError(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || String(e)).join(" ");
  return String(detail);
}
